/**
 * Просьба перечитать файлы с диска. Не uninstall.
 *
 * Живёт отдельно от распаковки zip: мостик расширения не должен тащить
 * inflate в служебный процесс.
 */

export const EXT_RELOAD = 'forq:ext-reload';

export function reloadEnvelope(): { channel: string } {
  return { channel: EXT_RELOAD };
}

export function parseReload(data: unknown): boolean {
  return typeof data === 'object' && data !== null && (data as { channel?: unknown }).channel === EXT_RELOAD;
}
